import useOnScreen, { useOnScreenCallback } from 'pathfinder/modules/shared/useOnScreen';
import { useCallback, useEffect } from 'react';
function useTracking(track, id, moduleName, onScreen) {
    const trackImpression = useCallback(() => {
        track.impression({
            label: `${id} | ${moduleName}-impression`,
        });
    }, [track]);
    const trackClick = useCallback(() => {
        track.click({
            label: `${id} | ${moduleName}-click`,
        });
    }, [track]);
    useEffect(() => {
        if (onScreen) {
            trackImpression();
        }
    }, [onScreen]);
    return trackClick;
}
export function useSponsoredWidgetTracking(track, id, moduleName, ref) {
    const onScreen = useOnScreen(ref);
    const trackClick = useTracking(track, id, moduleName, onScreen);
    return trackClick;
}
export function useSponsoredWidgetTrackingDelayed(track, id, moduleName) {
    const [onScreen, setOnScreenRef] = useOnScreenCallback();
    const trackClick = useTracking(track, id, moduleName, onScreen);
    return [trackClick, setOnScreenRef];
}
